import { createSlice } from "@reduxjs/toolkit";

export const enquiryListSlice = createSlice({
  name: "enquiryList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedEnquiry: null,
    filteredRecords: 0,
    isSingleEnquiryLoading: false,
    isLoading: false,
    isSingleEnquiryNotFound: false,
  },
  reducers: {
    setAllEnquiriesLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleEnquiryLoadingState: (state, action) => {
      state.isSingleEnquiryLoading = true;
    },
    loadAllEnquiries: (state, action) => {
      const listObj = {};
      action.payload.enquiries.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.enquiries.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleEnquiry: (state, action) => {
      state.selectedEnquiry =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleEnquiryLoading = false;
    },
    setSingleEnquiryNotFound: (state, action) => {
      state.isSingleEnquiryNotFound = action.payload;
    },
  },
});

export const {
  setAllEnquiriesLoadingState,
  setSingleEnquiryLoadingState,
  loadAllEnquiries,
  loadSingleEnquiry,
  setSingleEnquiryNotFound,
} = enquiryListSlice.actions;

export default enquiryListSlice.reducer;
